import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ApplicationService} from '../../../services/application.service';
import {EnumerationService} from '../../../services/enumeration.service';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-modal-file-to-receipt',
  templateUrl: './modal-file-to-receipt.component.html',
  styles: [
  ]
})
export class ModalFileToReceiptComponent extends ExcTranslation implements OnInit {
  @Input() data: any;

  selectedFiles = [] as any[];
  acceptedFileTypes = ['PDF', 'DOCX', 'XLSX', 'JPEG', 'PNG'];

  files = {
    selection: [],
  };

  skipFileUpload = false;
  mergeFileUpload = false;
  receipt = {
    rcpt_vorgID: undefined,
    rcptStatement: false,
    rcptStatementReason: '',
  };

  constructor(public modalService: ExgModalService,
              public appSvc: ApplicationService,
              public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.data) {
      this.receipt = JSON.parse(JSON.stringify(this.data.receipt));
      this.selectedFiles = this.data.selectedDocuments;
    }
  }

  delete(index: any): void {
    this.selectedFiles = this.selectedFiles.filter(file => file !== index);
  }

  isValidPDF(fileExtension: string): boolean {
    return this.acceptedFileTypes.includes(fileExtension.toUpperCase());
  }

  getFiles(): any[] {
    const files = this.selectedFiles.filter((file: any) => this.isValidPDF(file.dokMIME));
    if (!files) {
      return [];
    }
    return files;
  }

  move(index: number, dir: -1 | 1): void {
    const target = index + dir;
    if (target < 0 || target >= this.selectedFiles.length) {
      return;
    }
    const copy = [...this.selectedFiles];
    [copy[index], copy[target]] = [copy[target], copy[index]];
    this.selectedFiles = copy;
  }

  onFileDrop(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.selectedFiles, event.previousIndex, event.currentIndex);
      this.selectedFiles = [...this.selectedFiles];
    }
  }

  upload(): void {
    if (this.getFiles().length > 0) {
      this.modalService.action({selectedFiles: this.getFiles(), rcptStatementReason: this.receipt.rcptStatementReason});
      // this.modalService.action({
      //   formData: ExcFileItem.getFormData(this.getFiles(), this.receipt)
      //   , mergeFileUpload: this.mergeFileUpload
      //   , skipFileUpload: this.skipFileUpload
      // });
    }
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.modalService.close();
  }
}
